import axios from 'axios';
import apiPath from './apiPath';

const api = {
  uploadMenuList(payload) {
    const data = new FormData();
    data.append('file', payload.file);
    return axios({
      url: `${process.env.VUE_APP_QRAVED_APP_URL}/${
        apiPath.IMEX_BO_MENU_BY_TEMPLATE.path
      }?check_pages=11111111&from_web=true`,
      method: 'post',
      headers: { 'Content-Type': 'multipart/form-data' },
      data
    });
  }
};

export default api;
